import { render } from "./MenuAccordions.vue?vue&type=template&id=701a3660"
import script from "./MenuAccordions.vue?vue&type=script&lang=js"
export * from "./MenuAccordions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__